module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-3-79d5ea92dc98be7100296929ecc09b58.jpg";